import React, { ChangeEvent, useEffect, useState } from 'react';

import { FILTER_KEYS, MESSAGES, SCOPE } from '../../config/constants';
import Loader from '../Shared/Loader';
import { fixDecimals, isCC, isNCAAAllSports, isTA,  text_truncate,  arraySort } from '../../helpers';
import Table, { HeadsType, RowType } from '../Shared/CustomTable';
import { useFiltersState, useLoadingState, usePlayersDispatch, usePlayersState, useUserState } from '../../store/hooks';
import { useRouter } from '../../helpers/customHooks';
import { format, parse, isValid } from 'date-fns';

export default ({ teamId, league, selectedDate }: { teamId: string, league: string, selectedDate: Date | number }) => {
  
  const user = useUserState();
  const { scope, specificScope } = useRouter();
  const { customerPlayers = {} } = usePlayersState();
  const { getCustomerPlayers, setPlayerSpeed: setAccount, setPlayerCustomSpeed } = usePlayersDispatch();
  const current = useLoadingState(specificScope);
  useEffect(() => {
    if (league) {
      if (selectedDate) {
        const formattedDate = format(selectedDate, "yyyyMMdd");
        getCustomerPlayers(teamId, league, formattedDate);
      } else {
        getCustomerPlayers(teamId, league);
      }
    }
  }, [teamId, league, selectedDate]);
  const {
    [FILTER_KEYS.POSITIONS]: positionSelected
  } = useFiltersState(specificScope, FILTER_KEYS.POSITIONS);
  const [editInputValue, setEditInputValue] = useState({ player: '', input: '' });
  const [editCustomValue, setEditCustomValue] = useState({ player: '', customTargets: '', day:'' });
  const [modal, setModal] = useState<JSX.Element | null>(null);
  
  // CC's = 1006px
  // Other's = 1276px
  const handleSpeedChange = (e: ChangeEvent<HTMLInputElement>, isCustom: boolean)=>{
    const val= e.target.value;
    if (!/^\d*\.?\d*$/.test(val)) return;
    const parts = val.split(".");
    if (parts[1] && parts[1].length > 2) return;
       if (val === "") {
        if(isCustom){
          setEditCustomValue(prev => ({
          ...prev,
          customTargets: "",
          }));
          return;
        }else{
          setEditInputValue(prev => ({ ...prev, input: "" }));
        }
      
    }

    const num = parseFloat(val);
    if (isNaN(num)) return;

    if (num >= 1 && num <= 99) {
      if(isCustom){
        setEditCustomValue(prev => ({
        ...prev,
        customTargets: val,
      }));
    } else{
         setEditInputValue(prev => ({
        ...prev,
        input: val,
      }));
      }
  }
   
  };
const handleBlur = () => {
 
    setEditCustomValue(prev => ({
      ...prev,
      customTargets:
        prev.customTargets !== ""
          ? fixDecimals(+prev.customTargets, 2).toString()
          : "",
    }));
};

  const headers: HeadsType<string> = [
    {
      content: 'PLAYER',
      style: { width: isCC(user) ? '210px' : '314px' },
      class: (isCC(user) ? 'l-ll ' : '') + 't-ll',
      isOrderly: true
    },
    { content: 'NO.', style: { width: isCC(user) ? '70px' : '86px' }, class: 't-ll', isOrderly: true },
    { content: 'POS.', style: { width: isCC(user) ? '90px' : '86px' }, class: 't-ll', isOrderly: true },
    { content: 'ROLLING RELATIVE MAX', style: { width: isCC(user) ? '116px' : '160px', textAlign:'center' }, class: 't-ll' },
    {
      content: 'TEAM-DEFINED PLAYER RELATIVE SPEED',
      style: { width: isCC(user) ? '232px' : '319px', textAlign: 'right' },
      class: 't-ll'
    },
    {
      content: 'CUSTOM ZONE SPEED',
      style: { width: isCC(user) ? '288px' : '303px', textAlign: 'right' },
      class: scope === SCOPE.CUSTOMERS.PLAYERS.PAGE ? 't-ll' : ''
    }
  ];
  let positionFilter: string[];
  let players;
    if(positionSelected && positionSelected.length > 0){
      positionFilter = positionSelected.map(obj => obj.value);
    }
    if(customerPlayers[teamId] && positionSelected && positionSelected.length > 0){
      players = customerPlayers[teamId].filter(player => positionFilter.includes(player.position));
    }else {
      players = customerPlayers[teamId];
    }
  const rows: RowType[] = [];
  (players || []).forEach((player) => {
    const isEditing = editInputValue.player === player.key;
    const isEditingCustom = editCustomValue.player === player.key;
    const fallbackDate = new Date();
    const key = player.id;
    const stringDate = player.day;
    const parsed = stringDate ? parse(stringDate, 'yyyyMMdd', fallbackDate) : fallbackDate;
    const defaultDate = isValid(parsed) ? parsed : fallbackDate;

    const handleSaveCustomTarget = (playerPrevCustomTarget:string, isDelete?: boolean) => {
      const dateToSave = selectedDate || defaultDate;
      const formattedDate = format(dateToSave, 'yyyyMMdd');
      if(isDelete && playerPrevCustomTarget && league){
        setPlayerCustomSpeed(teamId, player, '0' ,league, formattedDate);
      }else{
        if(+playerPrevCustomTarget !== +editCustomValue.customTargets && !isDelete && editCustomValue.customTargets !=='' && league){
          setPlayerCustomSpeed(teamId, player, +editCustomValue.customTargets === -1 || editCustomValue.customTargets === '' ? "" : editCustomValue.customTargets, league, formattedDate);
        }
      }
    
      
    };
    rows.push({
      columns: [
        {
          content: {name: player.name, nameSplited: (player.name || '').split(' ').slice(-1).join(' ') },
          style: isEditing ? { background: '#f1f6fa' } : {},
          class: (isCC(user) ? 'l-ll ' : '') + 't-ll',
          print: content => <label className="l-c"><b>{text_truncate(content.name, 40)}</b></label>,
          order: (contentA, contentB) => {
            if (!Number.isNaN(+contentA.nameSplited) && !Number.isNaN(+contentB.nameSplited)) {
              return +contentB.nameSplited - +contentA.nameSplited;
            }
            return arraySort(contentB.nameSplited, contentA.nameSplited);
          }

        },
        {
          content: player.jerseyNumber,
          style: isEditing ? { background: '#f1f6fa' } : {},
          class: 't-ll',
          print: content => <label className="l-c rr-pp">#{content}</label>
        },
        {
          content: player.position,
          style: isEditing ? { background: '#f1f6fa' } : {},
          class: 't-ll',
          print: content => <label className="l-c rr-pp">{player.position}</label>
        },
        {
          content: (
            <label className="l-c rr-pp" style={{ display: 'flex', justifyContent: 'center' }}>
              <b>{player.rollinMax >= 0 ? fixDecimals(player.rollinMax, 1) : '-'}</b>
            </label>
          ),
          style: isEditing ? { background: '#f1f6fa' } : {},
          class: 't-ll'
        },
        {
          content: (
            <div className="t-l rr-pp">
              {isEditing ? (
                <>
                  <input
                    type="text"
                    inputMode='decimal'
                    value={ +editInputValue.input === -1 || editInputValue.input === '' ? '' : editInputValue.input}
                    onChange={(e)=>handleSpeedChange(e,false)}
                  />
                  <button
                    className="btn-blue"
                    onClick={() => {
                      const dateToSave = selectedDate || defaultDate;
                      const formattedDate = format(dateToSave, 'yyyyMMdd');
                      setAccount(teamId, player, +editInputValue.input === -1 || editInputValue.input === '' ? "" : editInputValue.input, league, formattedDate);
                      setEditInputValue({ player: '', input: '' });
                    }}
                    style={{ opacity: 1, width: '53px' }}
                  >
                    Save
                  </button>
                  <button
                    className="btn-gray"
                    onClick={() => setEditInputValue({ player: '', input: '' })}
                    style={{ opacity: 1, width: '65px', marginLeft: '10px' }}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <>
                  <label style={{ marginBottom: '28px' }}>{+player.speed !== -1 && player.speed !== '' ? player.speed : '-'}</label>
                  {(isTA(user) || isCC(user) || isNCAAAllSports(user)) && (
                    <button
                      className="btn-blue"
                      style={{ width: '53px' }}
                      onClick={() => setEditInputValue({ player: player.key, input: player.speed })}
                    >
                      Edit
                    </button>
                  )}
                </>
              )}
            </div>
          ),
          style: isEditing ? { background: '#f1f6fa' } : {},
          class: 't-ll'
        },
        {
          content: (
            <div className="t-l rr-pp">
            {isEditingCustom ? (
              <>
                <input
                  type="text"
                  inputMode='decimal'
                  value={+editCustomValue.customTargets === -1 || editCustomValue.customTargets === "" ? "": editCustomValue.customTargets}
                  onChange={(e)=>handleSpeedChange(e,true)}
                  onBlur={handleBlur}
                />  
                <button
                  className="btn-blue"
                  onClick={() => {
                    handleSaveCustomTarget(player.customTargetSpeed);
                    setEditCustomValue({ player: '', customTargets: '', day:'' });
                  }}
                  style={{ opacity: 1, width: '53px' }}
                >
                  Save
                </button>
                <button
                  className="btn-gray"
                  onClick={() =>{
                    handleSaveCustomTarget(player.customTargetSpeed, true);
                    setEditCustomValue({ player: '', customTargets: '', day:'' });
                  }}
                  style={{ opacity: 1, width: '65px', marginLeft: '10px' }}
                >
                  Delete
                </button>
              </>
            ) : (
              <> 
                <label style={{ marginBottom: '28px', width: '25px' }}>
                  {player.customTargetSpeed && +player.customTargetSpeed !== -1 && player.customTargetSpeed !== '' ? fixDecimals(+player.customTargetSpeed,2) : '-'}</label>
                {(isTA(user) || isCC(user) || isNCAAAllSports(user)) && (
                  <button
                    className="btn-blue"
                    style={{ width: '53px' }}
                    onClick={() => {
                      const formattedDate = format(selectedDate, 'yyyyMMdd');
                      setEditCustomValue({ player: player.key, customTargets: player.customTargetSpeed? fixDecimals(+player.customTargetSpeed, 2).toString(): "", day: formattedDate});}
                    }
                    key={player + 'custom'}
                  >
                    Edit
                  </button>
                )}
              </>
            )}
          </div>
          ),
          style: isEditingCustom ? { background: '#f1f6fa' } : {},
          class: 't-ll'
        }
      ],
      id: JSON.stringify(player)
    });
  });
  return (
    <>
      {modal}
      <Loader forceLoader={current.count > 0} forceMessage={!rows.length? MESSAGES.EMPTY : ''}>
        <Table
          classTable={`default-table-width ${isCC(user) ? ' table-with-borders' : 'customers-players-table'}`}
          headers={headers}
          rows={rows}
          withoutScroll={scope === SCOPE.CUSTOMERS.PLAYERS.PAGE}
          default={{ orderColumn: 1 }}
        />
      </Loader>
    </>
  );
};
